import React from "react";
import { secondaryColor, secondaryTextColorOppositeShade } from "../../utils/constants";

export default function NewFeedsIcon({ color = secondaryColor, color2 = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 61">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <rect fill={color2} width="61" height="61" rx="9.16" />
          <path
            fill={color}
            stroke={color}
            strokeMiterlimit="10"
            strokeWidth="1.5px"
            d="M33.93,45.18a3.46,3.46,0,0,1-6.86,0"
          />
          <path
            fill={color}
            stroke={color}
            strokeMiterlimit="10"
            strokeWidth="1.5px"
            d="M33.61,17.26V15.84a3,3,0,0,0-6.09,0v1.33c-4.72,1.13-8.21,4.88-8.21,9.39V38.77H41.49V26.56C41.49,22.16,38.15,18.48,33.61,17.26Z"
          />
          <path
            fill={color}
            stroke={color}
            strokeMiterlimit="10"
            strokeWidth="1.5px"
            d="M41.52,38.9l-22.6-.13c-1.87,1.51-4,3.07-3.6,4.95.14.66.64,1.09,1.53,1.37a2.39,2.39,0,0,0,.71.07l26.93,0c1.18,0,1.24-1.4,1.24-1.56C45.74,42,43.84,40.58,41.52,38.9Z"
          />
          <line
            strokeWidth="1.5px"
            strokeMiterlimit="10"
            fill="none"
            stroke={color2}
            x1="14.37"
            y1="38.4"
            x2="43.76"
            y2="38.45"
          />
          <line
            strokeMiterlimit="10"
            fill="none"
            stroke={color2}
            strokeWidth="0.75px"
            x1="13.46"
            y1="46.26"
            x2="47.05"
            y2="46.32"
          />
          <line
            strokeMiterlimit="10"
            fill="none"
            stroke={color2}
            strokeWidth="0.75px"
            x1="13.46"
            y1="46.36"
            x2="47.04"
            y2="46.42"
          />
        </g>
      </g>
    </svg>
  );
}
